module.exports = __webpack_public_path__ + "static/media/保腎護心網頁圖素材.69d606fa.png";